export default function categorySummary(category, subcategory) {
  if (subcategory.name && subcategory.name !== category.name) {
    return `${category.name} → ${subcategory.name}`;
  }

  return `${category.name}`;
}
